import React, { useState } from "react";
import {
  TextArea,
  MyMessage,
  InputField,
  AddPageShell,
  AddSection,
} from "../components/Component";
import { useStaticContext } from "../../context/StaticContext";
import { getOneFooter } from "../../lib/sysNavigation/SysNavigation";
import { FiLayout } from "react-icons/fi";

const Edit = () => {
  const { updateStaticContent } = useStaticContext();
  const footer: any = getOneFooter();

  const [error, setError] = useState<any>(false);
  const [message, setErrorMessage] = useState<any>("");
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState<any>(false);

  const footer_id = footer.footer_id;
  const [title, setTitle] = useState<any>(footer.title);
  const [description, setDescription] = useState<any>(footer.description);

  const footerRoutes = "/footer";

  const responses = (error: any, message: any) => {
    setError(error);
    setSuccess(!error);
    setErrorMessage(message);
    setLoading(false);
  };

  const updateOneFooterHandler = async (e: any) => {
    e.preventDefault();
    setLoading(true);
    await sendDBRequest();
  };

  /**
   * @author Ntavigwa Bashombe
   * @param {*} thumbnail
   * @returns
   */
  const sendDBRequest = async () => {
    const data = {
      title: title,
      description: description,
    };

    const { status, message } = await updateStaticContent(
      "footer",
      footer_id,
      data
    );
    if (status === 200) responses(false, message);
    else responses(true, message);
  };

  const clearMessages = () => {
    setError(null);
    setSuccess(null);
  };

  return (
    <AddPageShell
      backRoute={footerRoutes}
      eyebrow="Site • Footer"
      title="Edit Footer"
      subtitle="Update the title and description shown in the site footer."
      icon={<FiLayout className="h-5 w-5" />}
      loading={loading}
      submitLabel="Save Changes"
      onSubmit={updateOneFooterHandler}
      onSubmitClick={() => {
        setError(false);
        setSuccess(false);
        setErrorMessage(null);
      }}
      message={
        <MyMessage
          error={error}
          message={message}
          success={success}
          onExpired={() => {
            setError(false);
            setSuccess(false);
          }}
          onClick={() => {
            setError(false);
            setSuccess(false);
            setErrorMessage("");
          }}
        />
      }
    >
      <AddSection
        title="Basic Information"
        hint="The title is shown as the footer section heading."
      >
        <InputField
          props={{
            id: "title",
            title: "Title",
            type: "text",
            value: title ? title : "",
            onChange: (e: any) => {
              setTitle(e.target.value);
              clearMessages();
            },
          }}
        />
      </AddSection>

      <AddSection
        title="Description"
        hint="A concise summary (aim for ~120 characters)."
      >
        <TextArea
          props={{
            id: "description",
            title: "",
            type: "text",
            value: description ? description : "",
            rows: 6,
            onChange: (e: any) => {
              setDescription(e.target.value);
              clearMessages();
            },
          }}
        />
      </AddSection>
    </AddPageShell>
  );
};

export default Edit;
